<template>
  <nav>
    <v-app-bar
      app
      height="120"
      class="white py-0"
      flat
      :class="{
        transparent: this.$route.name == 'Home' && scrollPosition <= 0,
        changeColorWhite: this.$route.name == 'Home' && scrollPosition <= 0,
      }"
      :change="setPage()"
    >
      <v-container
        class="d-flex justify-space-between align-center col-10 pa-0 ma-0-auto"
      >
        <!-- brand -->
        <v-toolbar-title class="col-10 col-md-4 pa-0">
          <router-link class="text-decoration-none" to="/">
            <h1 class="nav-brand">
              <span class="px-2">NOVA</span>
              IMPACT
            </h1>
          </router-link>
        </v-toolbar-title>

        <div class="col-2 col-md-8 pa-0 d-flex justify-end align-center">
          <!-- menu links -->
          <v-menu
            flat
            open-on-hover
            offset-y
            rounded="0"
            v-for="link in $t('Navbar')"
            :key="link.title"
          >
            <template v-slot:activator="{ on, attrs }">
              <router-link
                class="text-decoration-none"
                :to="link.route"
                @click.native="scrollToTop"
              >
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  text
                  tile
                  class="px-3 nav-item black--text navbar-viz"
                  :class="{ navGreenHighlight: page == `${link.route}/` }"
                  >{{ link.title }}
                </v-btn>
              </router-link>
            </template>

            <!--             <v-list class="pa-0 ma-0">
              <v-list-item class="pa-0 ma-0">
                <v-list-item-title class="ma-0 pa-0 d-flex justify-end">
                  <DropdownMenuItem
                    :page="`${link.route}/`"
                    :menu="menuItemSelect(link.route)"
                  ></DropdownMenuItem>
                </v-list-item-title>
              </v-list-item>
            </v-list> -->
          </v-menu>

          <!-- i18n switcher -->
          <div class="navbar-viz">
            <LocaleSwitcher
              :mainTxt="{
                'white--text':
                  this.$route.name == 'Home' && scrollPosition <= 0,
                'black--text':
                  this.$route.name != 'Home' ||
                  (this.$route.name == 'Home' && scrollPosition > 0),
              }"
              :menuTxt="{
                'white--text':
                  this.$route.name == 'Home' && scrollPosition <= 0,
                'black--text':
                  this.$route.name != 'Home' ||
                  (this.$route.name == 'Home' && scrollPosition > 0),
              }"
              :menuBkg="{
                navWhiteHighlight:
                  this.$route.name == 'Home' && scrollPosition <= 0,
                navGreenHighlight:
                  this.$route.name != 'Home' ||
                  (this.$route.name == 'Home' && scrollPosition > 0),
              }"
            />
          </div>

          <!-- burger icon -->
          <v-app-bar-nav-icon
            fab
            class="green--text burger-icon sidebar-viz"
            @click="drawer = !drawer"
          ></v-app-bar-nav-icon>
        </div>
      </v-container>
    </v-app-bar>

    <!-- sidebar navigation -->
    <v-navigation-drawer
      v-model="drawer"
      app
      fixed
      right
      disable-resize-watcher
      temporary
      hide-overlay
      class="green sidebar-viz"
      width="100%"
      height="100%"
    >
      <div
        class="d-flex col-10 pa-0 mx-auto
          justify-space-between
          align-center drawer-top"
      >
        <div class="col-auto pa-0">
          <h1 class="white--text nav-brand">
            <span class="px-2 white green--text">NOVA</span>
            IMPACT
          </h1>
        </div>

        <div class="col-2 pa-0 text-right">
          <LocaleSwitcher
            :mainTxt="{ 'white--text': 'true' === 'true' }"
            :menuTxt="{ 'white--text': 'true' === 'true' }"
            :menuBkg="{ navGreenHighlight: 'true' === 'true' }"
          />
        </div>
        <div class="col-2 pa-0 text-right">
          <v-btn icon @click.stop="drawer = !drawer">
            <v-icon class="burger-icon white--text">mdi-window-close</v-icon>
          </v-btn>
        </div>
      </div>

      <v-list class="col-10 mx-auto pa-0 drawer-main-menu">
        <v-list-item
          v-for="link in $t('Navbar')"
          :key="link.title"
          class="pa-0 nav-item drawer-main-menu-item"
        >
          <v-list-item-content class="pa-0">
            <v-list-item-title>
              <router-link
                class="text-decoration-none"
                :to="link.route"
                @click.native="scrollToTop"
              >
                <v-btn
                  text
                  tile
                  class="white--text sidebar-viz d-flex justify-start nav-item drawer-main-menu-item"
                  :class="{ navWhiteHighlight: page == `${link.route}/` }"
                  >{{ link.title }}
                </v-btn>
              </router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <div class="col-12 lightgray drawer-sec-menu pa-0">
        <v-list class="col-10 ma-auto ma-0 pa-0 drawer-sec-menu">
          <v-list-item>
            <SideMenu
              :page="page"
              :menu="sideMenu"
              v-if="
                ['about', 'academics', 'industry', 'technologies'].some(el =>
                  this.$route.fullPath.includes(el)
                )
              "
            ></SideMenu>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import LocaleSwitcher from '@/components/LocaleSwitcher.vue'
import SideMenu from '@/components/SideMenu.vue'
// import DropdownMenuItem from '@/components/DropdownMenuItem.vue'

export default {
  name: 'Navbar',
  components: {
    LocaleSwitcher,
    SideMenu,
    // DropdownMenuItem,
  },
  data() {
    return {
      scrollPosition: null,
      drawer: false,
      page: '',
      sideMenu: '',
      allMenus: {
        '/about': 'SideMenuAbout',
        '/academics': 'SideMenuAcademics',
        '/industry': 'SideMenuIndustry',
        '/technologies': 'SideMenuTechnologies',
      },
    }
  },
  methods: {
    setPage() {
      if (this.$route.fullPath.includes('about')) {
        this.page = '/about/'
        this.sideMenu = 'SideMenuAbout'
      } else if (this.$route.fullPath.includes('academics')) {
        this.page = '/academics/'
        this.sideMenu = 'SideMenuAcademics'
      } else if (this.$route.fullPath.includes('industry')) {
        this.page = '/industry/'
        this.sideMenu = 'SideMenuIndustry'
      } else if (this.$route.fullPath.includes('technologies')) {
        this.page = '/technologies/'
        this.sideMenu = 'SideMenuTechnologies'
      } else {
        this.page = '/home/'
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    menuItemSelect(menuItemRoute) {
      return this.allMenus[menuItemRoute]
    },
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll)
  },
}
</script>

<style lang="scss">
.v-toolbar__content {
  justify-content: space-between;
  padding: 0 !important;
}

.changeColorWhite {
  .theme--light.v-btn,
  .nav-item {
    color: white !important;
    &:hover {
      background-color: rgba(white, 0.2) !important;
    }
  }
  .nav-brand {
    color: white !important;
    span {
      max-height: 40px;
      background-color: white !important;
      color: #272727 !important;
    }
  }
}

.nav-brand {
  font-family: $heading-font-family;
  font-weight: 900;
  font-size: 14px;
  text-transform: uppercase;
  height: 25px !important;
  line-height: 25px;
  color: #1bb493;

  span {
    display: inline-block;
    background-color: #1bb493;
    color: white;
  }
}

.nav-item {
  font-family: $body-font-family;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  min-height: 40px !important;
  height: 40px !important;
  line-height: 40px;
  letter-spacing: -0.05px;
  span {
    height: 40px !important;
    line-height: 40px;
  }
}
nav .nav-item:hover {
  background-color: rgba(#1bb493, 0.2) !important;
}

.navGreenHighlight {
  background-color: rgba(#1bb493, 0.2) !important;
}

.navWhiteHighlight {
  background-color: rgba(white, 0.2) !important;
}

.burger-icon,
.burger-icon i {
  font-size: 48px !important;
}

.navbar-viz {
  display: none !important;
  @media screen and (min-width: 1300px) {
    display: block !important;
  }
}

.sidebar-viz {
  display: block !important;
  @media screen and (min-width: 1300px) {
    display: none !important;
  }
}

.drawer-top {
  height: 120px;
  .nav-brand {
    opacity: 0.2;
  }
}

.drawer-main-menu {
  height: 200px;
  .drawer-main-menu-item {
    width: 100%;
  }
}

.drawer-sec-menu {
  min-height: calc(100vh - 320px);
  .v-list-item {
    padding: 0 !important;
  }
}
</style>
